// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 300) return "static/css/300.48fd99788df4933b20b8.lib.css";
	if (chunkId === 639) return "static/css/639.6046297fb4249b5033de.css";
	// return url for filenames based on template
	return undefined;
};